import { createSlice } from '@reduxjs/toolkit'

const defaultData = {
  allowCookie: false,
  active: 0,
  openCookieDrawer: false,
  openCookieDialog: false,
  styleMember : 'unselected',
  styleShop: 'unselected',
  textColorList: ['text-gray', 'text-gray'],
  address : '',
  firstName: '',
  lastName: '',
  email: '',
  mobileNumber: '',
  birthDate: null,
  subDistrict: null,
  subDistrictId: null,
  amphoe: '',
  amphoeId: null,
  province: '',
  provinceId: null,
  zipCode: '',
  isDeliveryAddress: false,
  deAddress: '',
  deSubDistrict: '',
  deSubDistrictId: null,
  deAmphoe: '',
  deAmphoeId: null,
  deProvince: '',
  deProvinceId: null,
  deZipCode: '',
  recommendCode: '',
  question1: null,
  question2: null,
  question3: null,
  question4: null,
}

export const RegisterMainSlice = createSlice({
  name: 'registerMain',
  initialState: defaultData,
  reducers: {
    setRegisterMain: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        // console.log(`${key}: ${value}`);
        state[key] = value;
      }
    },
    resetRegisterMain: () => defaultData
  },
})

// Action creators are generated for each case reducer function
export const {
  setRegisterMain,
  resetRegisterMain
} = RegisterMainSlice.actions

export default RegisterMainSlice.reducer